import { ErrorHandler, Injectable } from '@angular/core';
import { LogLevel, LogService } from '../services/log.service';

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
  constructor(private readonly logService: LogService) {}

  public handleError(error: TypeError) {
    console.error(error);
    this.logService.addLog({
      message: error.message,
      level: LogLevel.ERROR,
      traceId: this.logService.getTraceId(),
      stack: error.stack
    });
  }
}
